"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getSsoClientId = exports.getAuthState = exports.initializeAuthState = exports.UNAUTH_STATE = exports.UNSET_AUTH_STATE = exports.AuthStatus = void 0;
var logger_1 = require("../logger");
var log = (0, logger_1.getLogger)("authState");
var AuthStatus;
(function (AuthStatus) {
    AuthStatus[AuthStatus["AUTHENTICATED"] = 0] = "AUTHENTICATED";
    AuthStatus[AuthStatus["UNAUTHENTICATED"] = 1] = "UNAUTHENTICATED";
    AuthStatus[AuthStatus["UNKNOWN"] = 2] = "UNKNOWN";
})(AuthStatus = exports.AuthStatus || (exports.AuthStatus = {}));
exports.UNSET_AUTH_STATE = Object.freeze({
    authStatus: AuthStatus.UNKNOWN
});
exports.UNAUTH_STATE = Object.freeze({
    authStatus: AuthStatus.UNAUTHENTICATED
});
var ssoClientId = undefined;
var authStatePromise = undefined;
function initializeAuthState(clientAuthProvider) {
    if (clientAuthProvider === null) {
        log.debug("Setting no-op unauthenticated clientAuthProvider");
        authStatePromise = Promise.resolve(exports.UNAUTH_STATE);
        ssoClientId = null;
        return;
    }
    ssoClientId = clientAuthProvider.ssoClientId;
    authStatePromise = new Promise(function (resolve) {
        clientAuthProvider.authState.subscribe(function (newAuthState) {
            log.debug("Got new authState:", newAuthState);
            if (newAuthState === exports.UNSET_AUTH_STATE) {
                return;
            }
            resolve(newAuthState);
            authStatePromise = Promise.resolve(newAuthState);
        });
    });
}
exports.initializeAuthState = initializeAuthState;
function getAuthState() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!authStatePromise) {
                throw new Error("getAuthState called before setClientAuthProvider, was initBlizzard called?");
            }
            return [2, authStatePromise];
        });
    });
}
exports.getAuthState = getAuthState;
function getSsoClientId() {
    if (ssoClientId === undefined) {
        throw new Error("getSsoClientId called before setClientAuthProvider, was initBlizzard called?");
    }
    return ssoClientId;
}
exports.getSsoClientId = getSsoClientId;
//# sourceMappingURL=authState.js.map